import { Button, ButtonProps } from "@mui/material"

type RoundedButtonProps = ButtonProps & {
  rounded?: "filled" | "outlined";
  bgColor?: string;
  textColor?: string;
};

export const RoundedButton = ({
  children,
  sx,
  rounded = "filled",
  bgColor = "#46abe3",
  textColor = "#fff",
  ...props
}: RoundedButtonProps) => {
  const isOutlined = rounded === "outlined";

  return (
    <Button
      variant={isOutlined ? "outlined" : "contained"}
      sx={{
        backgroundColor: isOutlined ? "transparent" : bgColor,
        color: isOutlined ? bgColor : textColor,
        fontWeight: 700,
        borderRadius: "999px",
        padding: "10px 28px",
        textTransform: "none",
        boxShadow: "none",
        border: `1px solid ${bgColor}`,
        "&:hover": {
          backgroundColor: isOutlined ? bgColor : `${bgColor}cc`,
          color: isOutlined ? textColor : textColor,
          border: `1px solid ${bgColor}`,
          boxShadow: "none",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}